(() => {
  const SECTION_SELECTOR = '[data-ct-curated-gift-rows]';
  const ROW_SELECTOR = '[data-ct-curated-row]';

  function clamp(value, minimum, maximum) {
    return Math.min(Math.max(value, minimum), maximum);
  }

  function initialiseRow(row) {
    if (!row || row.dataset.ctCuratedInitialised === 'true') {
      return;
    }

    const viewport = row.querySelector(
      '[data-ct-curated-viewport]'
    );

    const previousButton = row.querySelector(
      '[data-ct-curated-previous]'
    );

    const nextButton = row.querySelector(
      '[data-ct-curated-next]'
    );

    const progress = row.querySelector(
      '[data-ct-curated-progress]'
    );

    if (
      !viewport ||
      !previousButton ||
      !nextButton ||
      !progress
    ) {
      return;
    }

    row.dataset.ctCuratedInitialised = 'true';

    let pageCount = 1;
    let currentPage = 0;
    let scrollFrame = null;

    function getMaximumScroll() {
      return Math.max(
        0,
        viewport.scrollWidth - viewport.clientWidth
      );
    }

    function calculatePageCount() {
      const maximumScroll = getMaximumScroll();

      if (maximumScroll <= 3) {
        return 1;
      }

      return Math.max(
        2,
        Math.ceil(
          viewport.scrollWidth / viewport.clientWidth
        )
      );
    }

    function calculateCurrentPage() {
      const maximumScroll = getMaximumScroll();

      if (maximumScroll <= 3 || pageCount <= 1) {
        return 0;
      }

      const scrollProgress = viewport.scrollLeft / maximumScroll;

      return clamp(
        Math.round(scrollProgress * (pageCount - 1)),
        0,
        pageCount - 1
      );
    }

    function scrollToPage(pageIndex) {
      const maximumScroll = getMaximumScroll();
      const safePageIndex = clamp(
        pageIndex,
        0,
        pageCount - 1
      );

      const targetScroll =
        pageCount <= 1
          ? 0
          : maximumScroll *
            (safePageIndex / (pageCount - 1));

      viewport.scrollTo({
        left: targetScroll,
        behavior: 'smooth'
      });
    }

    function buildProgress() {
      progress.innerHTML = '';

      if (pageCount <= 1) {
        progress.hidden = true;
        return;
      }

      progress.hidden = false;

      for (
        let pageIndex = 0;
        pageIndex < pageCount;
        pageIndex += 1
      ) {
        const progressButton =
          document.createElement('button');

        progressButton.type = 'button';
        progressButton.className =
          'ct-curated-gift-rows__progress-button';

        progressButton.setAttribute(
          'aria-label',
          `Go to product page ${pageIndex + 1}`
        );

        progressButton.addEventListener('click', () => {
          scrollToPage(pageIndex);
        });

        progress.appendChild(progressButton);
      }
    }

    function updateControls() {
      const maximumScroll = getMaximumScroll();

      currentPage = calculateCurrentPage();

      previousButton.disabled =
        viewport.scrollLeft <= 3;

      nextButton.disabled =
        viewport.scrollLeft >= maximumScroll - 3;

      const progressButtons = progress.querySelectorAll(
        '.ct-curated-gift-rows__progress-button'
      );

      progressButtons.forEach(
        (progressButton, progressIndex) => {
          const isActive = progressIndex === currentPage;

          progressButton.classList.toggle(
            'is-active',
            isActive
          );

          progressButton.setAttribute(
            'aria-current',
            isActive ? 'true' : 'false'
          );
        }
      );
    }

    function refresh() {
      const nextPageCount = calculatePageCount();

      if (nextPageCount !== pageCount) {
        pageCount = nextPageCount;
        buildProgress();
      }

      updateControls();
    }

    previousButton.addEventListener('click', () => {
      scrollToPage(currentPage - 1);
    });

    nextButton.addEventListener('click', () => {
      scrollToPage(currentPage + 1);
    });

    viewport.addEventListener(
      'scroll',
      () => {
        if (scrollFrame) {
          window.cancelAnimationFrame(scrollFrame);
        }

        scrollFrame = window.requestAnimationFrame(() => {
          updateControls();
          scrollFrame = null;
        });
      },
      { passive: true }
    );

    if ('ResizeObserver' in window) {
      const resizeObserver = new ResizeObserver(() => {
        refresh();
      });

      resizeObserver.observe(viewport);
    } else {
      window.addEventListener('resize', refresh);
    }

    refresh();

    window.setTimeout(refresh, 300);
  }

  function initialiseSection(section) {
    if (!section) {
      return;
    }

    section.querySelectorAll(ROW_SELECTOR).forEach(
      initialiseRow
    );
  }

  function initialiseAllSections(scope = document) {
    scope.querySelectorAll(SECTION_SELECTOR).forEach(
      initialiseSection
    );
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      initialiseAllSections();
    });
  } else {
    initialiseAllSections();
  }

  document.addEventListener(
    'shopify:section:load',
    (event) => {
      const loadedSection = event.target;

      if (
        loadedSection.matches &&
        loadedSection.matches(SECTION_SELECTOR)
      ) {
        initialiseSection(loadedSection);
        return;
      }

      initialiseAllSections(loadedSection);
    }
  );
})();